// What's a duck? see https://github.com/erikras/ducks-modular-redux

import actions from './actions';
import helpers from './helpers';
import reducer from './reducer';

export default {actions, helpers, reducer};
